@if (showBanner()) {
      <div class="cookie-banner" [class.cookie-banner--visible]="showBanner()">
        <div class="cookie-banner__content">
          <div class="cookie-banner__text">
            <mat-icon class="cookie-banner__icon">cookie</mat-icon>
            <div>
              <h3 class="cookie-banner__title">Folosim cookie-uri</h3>
              <p class="cookie-banner__description">
                Acest site folosește cookie-uri esențiale pentru a asigura funcționarea corectă și autentificarea securizată.
              </p>
            </div>
          </div>
          
          <div class="cookie-banner__actions">
            <button 
              mat-button 
              class="cookie-banner__manage-btn"
              (click)="openPreferences()"
              [disabled]="isLoading()">
              Gestionează preferințele
            </button>
            
            <button 
              mat-raised-button 
              color="primary"
              class="cookie-banner__accept-btn"
              (click)="acceptCookies()"
              [disabled]="isLoading()">
              @if (isLoading()) {
                <mat-spinner diameter="16"></mat-spinner>
              } @else {
                Acceptă
              }
            </button>
          </div>
        </div>
      </div>
}
